/* eslint-disable react/no-array-index-key */
import { Form, Input } from 'antd';
import { CloseOutlined } from 'farmhub-ui-core';

import { OrderStatus, OrderTable, SearchTable } from 'components';
import { SELECT_MODE, SIZE } from 'utils/constants';

import { CustomSelect, Wrapper, WrapperIcon, WrapperStatus } from './styles';

interface DataItem {
  name: string;
  list?: any;
  placeholder?: string;
  mode?: 'multiple' | 'tags' | undefined;
}

interface FilterTableProps {
  name: string;
  searchName?: string;
  searchPlaceholder?: string;
  form: any;
  data: DataItem[];
  searchWidth?: number | string;
  size?: SIZE;
  initDataDefault?: (string | number)[];
  isHaveInitValue?: boolean;
  styles?: any;
  width?: string;
  extraAction?: React.ReactNode;
  handleFilterFormChange?: (e: any) => void;
}

const ShortFilterTable = ({
  name,
  searchName,
  searchPlaceholder,
  data,
  form,
  searchWidth,
  size = SIZE.DEFAULT,
  initDataDefault = [],
  isHaveInitValue = false,
  styles,
  width = '100%',
  extraAction,
  handleFilterFormChange,
}: FilterTableProps): JSX.Element => {
  const handleChangeFilter = (e = {}) => {
    const key = Object.keys(e)[0];
    const value: any = Object.values(e)[0];
    let newValue = e;

    if (Array.isArray(value)) {
      if (value.length === 0) {
        newValue = {
          [key]: initDataDefault,
        };
        form.setFieldsValue(newValue);
      } else if (key === 'where.statuses' || key === 'where.status') {
        const lastValue = value[value.length - 1];
        if (lastValue === 'all') {
          form.setFieldsValue({ [key]: ['all'] });
          newValue[key] = ['all'];
        } else {
          const clearString = value.filter(val => typeof val === 'number');

          form.setFieldsValue({ [key]: clearString });
          newValue[key] = clearString;
        }
      }
    }

    handleFilterFormChange && handleFilterFormChange(newValue);
  };

  const tagRender = (props: any): JSX.Element => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <WrapperStatus>
        <OrderStatus label={label} status={value} />
        <WrapperIcon onClick={onClose} onMouseDown={onPreventMouseDown}>
          <CloseOutlined />
        </WrapperIcon>
      </WrapperStatus>
    );
  };

  return (
    <Form form={form} style={{ width }} onValuesChange={handleChangeFilter}>
      {data?.length === 0 ? (
        <>
          {searchName && (
            <Form.Item
              name={searchName || 'search'}
              style={{ marginBottom: 0 }}
            >
              <SearchTable
                extraAction={extraAction}
                height={size === SIZE.SMALL ? 'sm' : 'md'}
                placeholder={searchPlaceholder || `Tìm theo tên ${name}`}
                width="100%"
              />
            </Form.Item>
          )}
        </>
      ) : (
        <Input.Group compact style={{ width: '100%', ...styles }}>
          {data.map((item: DataItem, index: number) => {
            if (item.name === 'order') {
              return (
                <Form.Item
                  key={index}
                  name={item.name}
                  style={{ marginBottom: 0 }}
                >
                  <OrderTable
                    height={size === SIZE.SMALL ? '36px' : '42px'}
                    list={item.list}
                  />
                </Form.Item>
              );
            }
            return (
              <Form.Item
                key={index}
                name={item.name}
                style={{ marginBottom: 0 }}
                {...(isHaveInitValue && {
                  initialValue: item.list.length > 0 ? item.list[0].value : '',
                })}
              >
                <CustomSelect
                  height={size === SIZE.SMALL ? 'sm' : 'md'}
                  list={item.list}
                  mode={item.mode}
                  placeholder={item.placeholder}
                  tagRender={tagRender}
                  width={item.mode === SELECT_MODE.MULTIPLE ? '400px' : '180px'}
                />
              </Form.Item>
            );
          })}
          {searchName && (
            <Wrapper>
              <Form.Item
                name={searchName || 'search'}
                style={{ marginBottom: 0 }}
              >
                <SearchTable
                  extraAction={extraAction}
                  height={size === SIZE.SMALL ? 'sm' : 'md'}
                  placeholder={searchPlaceholder || `Tìm theo tên ${name}`}
                  width={searchWidth || 290}
                />
              </Form.Item>
            </Wrapper>
          )}
        </Input.Group>
      )}
    </Form>
  );
};

export default ShortFilterTable;
